import {Component, HostListener, OnDestroy, OnInit, ViewContainerRef} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '@sharedenvironment';
import {NeqGoogleAnalyticsService} from '@sharedcommon/services/neq-google-analytics.service';
import { Subject } from 'rxjs';
import { UserService } from '@sharedcommon/services/user.service';
import { AuthenticationService } from '@usercommon/service/authentication.service';

@Component({
  selector: 'neq-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

  private readonly _destroying$ = new Subject<void>();

  constructor(private readonly translate: TranslateService,
              private readonly viewContainerRef: ViewContainerRef,
              private readonly googleAnalyticsService: NeqGoogleAnalyticsService,
              private readonly user: UserService,
              private readonly authenticationService: AuthenticationService) {
  }

  @HostListener('window:focus') onFocus() {
    // ALPVL1B-331: Force a reload of the page to trig guard if user is change when the focus come back
    const user = this.user.getUser();
    if (user) {
      let activeAccount = this.authenticationService.setAndGetAzureAccount();
      if (activeAccount) {
        const claims: any = activeAccount.idTokenClaims;
        if (claims) {
          if (this.user.getUser().full_name != claims.name) {
            // existing user in memory doesn't match the one of the token -> reload
            window.location.reload();
          }
        } else {
          // no claims in token but existing user in memory -> reload
          window.location.reload();
        }
      } else {
        // user is logout -> reload
        window.location.reload();
      }
    }
  }

  ngOnInit() {
    // Because some components need it and it wont compile if it is unused
    // tslint:disable-next-line:no-unused-expression
    this.viewContainerRef; //NOSONAR

    this.translate.addLangs(environment.translate.supportedLang);

    this.googleAnalyticsService.initGoogleAnalytics();

  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

}
